import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/vat-partner-edit';
import { callSettingsApiGet, callApiV2Put, callApiV2Post } from 'utilities/apiCaller';
import API from 'constants/api';
import { generateErrors, generateVatPartnersUpdateErrors } from 'utilities/util';
import { IStore } from 'reducers/index';

export const addUpdateVatPartnersISSO = () => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ISSO.PENDING });
		try {
			const res = await callApiV2Put(API.VatPartners.updateVatPartnersIsso, {}, {});
			dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ISSO.FULFILLED, payload: res.data });
		} catch (e) {
			const errors = generateVatPartnersUpdateErrors(e);
			dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ISSO.REJECTED, payload: errors });
		}
	};
};

export const addUpdateVatPartnersESSO = (vatPartnersData: any) => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ESSO.PENDING });
		try {
			const res = await callApiV2Put(API.VatPartners.updateVatPartnersEsso, vatPartnersData, {});
			dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ESSO.FULFILLED, payload: res.data });
		} catch (e) {
			const errors = generateVatPartnersUpdateErrors(e);
			dispatch({ type: TYPES.UPDATE_VAT_PARTNER_ESSO.REJECTED, payload: errors });
		}
	};
};

export const fetchVatPartners = () => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		try {
			const res = await callSettingsApiGet(API.FinanceConfig.VatPartners, {limit: 1000});
			dispatch({ type: TYPES.FETCH_VAT_PARTNERS.FULFILLED, payload: res.data });
		} catch (e) {
			const errors = generateErrors(e);
			dispatch({ type: TYPES.FETCH_VAT_PARTNERS.REJECTED, payload: errors });
		}
	};
};

export const fetchVatPartnerEditReasons = () => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		const reasonCodeCategory = 'VatPartner';
		const page = 1;
		const limit = 1000;
		try {
			const res = await callSettingsApiGet(API.FinanceConfig.ReasonCodes, { reasonCodeCategory, page, limit });
			dispatch({ type: TYPES.FETCH_VAT_PARTNER_EDIT_REASONS.FULFILLED, payload: res.data });
		} catch (e) {
			const errors = generateErrors(e);
			dispatch({ type: TYPES.FETCH_VAT_PARTNER_EDIT_REASONS.REJECTED, payload: errors });
		}
	};
};

export const setVatPartnersTableData = (payload: any) => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.SET_VAT_PARTNERS_TABLE_DATA, payload });
	};
};

export const setVatPartnersTableRows = (payload: any) => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.SET_VAT_PARTNERS_TABLE_ROWS, payload });
	};
};

export const setVatPartnersTableRow = (payload: any) => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.SET_VAT_PARTNERS_TABLE_ROW, payload });
	};
};

export const clearVatPartnersTableData = () => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.CLEAR_VAT_PARTNERS_TABLE_DATA });
	};
};

export const fetchVatPartnerValue = (documentType: string, requestObject: any) => {
	const importUrl = API.VatPartners.fetchImportVatPartnerValue;
	const exportUrl = API.VatPartners.fetchExportVatPartnerValue;
	const requestUrl = documentType.toLowerCase() === 'export' ? exportUrl : importUrl;
	return (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
		dispatch({ type: TYPES.FETCH_VAT_PARTNER_VALUE.PENDING });
		return new Promise((resolve, reject) => {
			callApiV2Post(requestUrl, requestObject)
				.then((res) => {
					dispatch({
						type: TYPES.FETCH_VAT_PARTNER_VALUE.FULFILLED,
						payload: res.data
					});
					resolve(res.data);
				})
				.catch((e) => {
					dispatch({
						type: TYPES.FETCH_VAT_PARTNER_VALUE.REJECTED,
						payload: 'Error fetching vat partner value'
					});
					reject('Error fetching vat partner value');
				});
		});
	};
};